import { request } from './client';

// The signed-in player's own account settings. Everything here acts on the
// session's player - there is no id to pass, and no way to touch anyone else's.

/**
 * Change your display name. This is the only name shown to players outside your
 * own leagues, so it is worth picking one people recognise. Errors arrive as
 * ApiError with body {error: message} - taken, too short, bad characters.
 */
export function updateDisplayName(displayName) {
  return request('/api/customer/profile/display-name', {
    method: 'PUT',
    body: { displayName },
  });
}

/**
 * Change your own password. The account is taken from the session cookie, never
 * sent - knowing the current password is the check, not the identity. Errors
 * arrive as ApiError with body {error: message} - current password wrong, new
 * one too short, new one unchanged.
 */
export function changePassword({ currentPassword, newPassword }) {
  return request('/api/customer/profile/password', {
    method: 'PUT',
    body: { currentPassword, newPassword },
  });
}

/**
 * What this player wants in their inbox.
 *
 * A player who has never touched the screen has no row on the server and gets the
 * shipped defaults rather than a 404 - so this always answers with three booleans and
 * the screen never has an "unknown" state to render.
 *
 * The unsubscribe token is deliberately not in the response. It is a long-lived bearer
 * credential whose only job is to work from an email with no session, and somebody
 * reading this endpoint already has a session.
 */
export function getEmailPreferences() {
  return request('/api/customer/profile/email-preferences');
}

/**
 * Set all three at once.
 *
 * Every field goes every time rather than patching one. The screen shows three switches
 * so it always knows all of them, and a partial update reads identically to a full one
 * right up until it silently leaves one wherever an unsubscribe link put it.
 */
export function updateEmailPreferences({
  notifyInvitations, notifyRequests, notifyPicks, notifyResults,
}) {
  return request('/api/customer/profile/email-preferences', {
    method: 'PUT',
    body: { notifyInvitations, notifyRequests, notifyPicks, notifyResults },
  });
}
